// material-ui
import { useOutletContext } from 'react-router';

import React, {useEffect} from "react";
import { Auth } from 'aws-amplify';

// material-ui
import {
  Autocomplete,
  Box,
  Button,
  CardHeader,
  Chip,
  Divider,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField
} from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';


// third party
import * as Yup from 'yup';
import { Formik } from 'formik';
import { handleSetUserAttributes } from "../../../../store/reducer/authuser";
import MainCard from '../../../../Components/MainCard';
import { openSnackbar} from "../../../../store/reducer/snackbar";

// assets
import { CloseOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from "react-redux";
import countries from '../../../../data/countries';
import {dispatch} from "../../../../store";

// styles & constant
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP
    }
  }
};

function useInputRef() {
  return useOutletContext();
}

const TabPersonal = () => {
  const inputRef = useInputRef();
  const dispatch = useDispatch();
  async function updateUserAttributes(firstname, middlename, lastname, email, dob, countryCode, contact, address, state) {
    try {
        console.log(Object.keys(dob));
        console.log(dob.getFullYear());
        console.log(dob.getDate());
        console.log(dob.getMonth())
        let year = dob.getFullYear();
        let day = dob.getDate();
        day = day.toString().padStart(2, '0');
        let month = dob.getMonth() + 1
        month = month.toString().padStart(2, '0');
        console.log(day + '/' + month + '/' + year);
      const user = await Auth.currentAuthenticatedUser();
      const result = await Auth.updateUserAttributes(user, {
        given_name: firstname,
          middle_name: middlename,
          family_name: lastname,
          email: email,
          birthdate: day + '/' + month + '/' + year,
          phone_number: countryCode + contact,
          address: address,
          locale: state
      })
      console.log(result)
        return {"status": 1, "message": "Profile changed successfully."}
        // dispatch(
        //     handleSetUserAttributes({
        //         user_attributes: user['attributes']
        //     })
        // );
      // console.log(result);
      return user
      // return {"status": 1, "message": "Profile changed successfully."};;
    } catch (err) {
      console.log(err);
      console.log(err.message);
      return {"status": 0, "message": err.message};
    }
  }

  // const user = getAuthenticatedUser();
  // console.log(user);
  const user_attributes = useSelector((state) => {
      return state.authuser.user_attributes
  })

    console.log(user_attributes);

  const handleChangeDay = (event, date, setFieldValue) => {
      console.log(event)
    setFieldValue('dob', new Date(date.setDate(parseInt(event.target.value, 10))));
  };

  const handleChangeMonth = (event, date, setFieldValue) => {
    setFieldValue('dob', new Date(date.setMonth(parseInt(event.target.value, 10))));
  };

  const maxDate = new Date();
  maxDate.setFullYear(maxDate.getFullYear() - 18);

  const email = useSelector((state) => {
    return state.authuser.username
  })

    return(
        <MainCard content={false} title="Personal Information" sx={{ '& .MuiInputLabel-root': { fontSize: '0.875rem' } }}>
          <Formik
        initialValues={{
          firstname: user_attributes['given_name']?user_attributes['given_name']:"",
          middlename: user_attributes['middle_name']?user_attributes['middle_name']:"",
          lastname: user_attributes['family_name']?user_attributes['family_name']:"",
          email: email,
          dob: user_attributes['birthdate']?new Date(user_attributes['birthdate'].split('/')[1]+'/'+user_attributes['birthdate'].split('/')[0]+'/'+user_attributes['birthdate'].split('/')[2]):new Date("01/01/1970"),
          countryCode: user_attributes['phone_number']?user_attributes['phone_number'].slice(0, -10):'',
          contact: user_attributes['phone_number']?user_attributes['phone_number'].slice(-10):'',
          address: user_attributes['address']?user_attributes['address']:"",
          state: user_attributes['locale']?user_attributes['locale']:"",
          submit: null
        }}
        validationSchema={Yup.object().shape({
          firstname: Yup.string().max(255).required('First Name is required.'),
          middlename: Yup.string().max(255),
          lastname: Yup.string().max(255).required('Last Name is required.'),
          email: Yup.string().email('Invalid email address.').max(255).required('Email is required.'),
          dob: Yup.date().max(maxDate, 'Age should be 18+ years.').required('Date of birth is required.'),
          contact: Yup.number(),
          address: Yup.string().min(20, 'Address to short.'),
          state: Yup.string()
        })}
        enableReinitialize={true}
        onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
            console.log(values);
            try {
                let success = await updateUserAttributes(
                    values.firstname,
                    values.middlename,
                    values.lastname,
                    values.email,
                    values.dob,
                    values.countryCode,
                    values.contact,
                    values.address,
                    values.state
                )
                if (success['status']===1) {
                    dispatch(
                        openSnackbar({
                            open: true,
                            message: success['message'],
                            variant: 'alert',
                            alert: {
                                color: 'success'
                            },
                            close: false
                        })
                    );
                }
                else {
                    console.log(success);
              dispatch(
                  openSnackbar({
                    open: true,
                    message: success['message'],
                    variant: 'alert',
                    alert: {
                      color: 'error'
                    },
                    close: false
                  })
              );
                }
            setStatus({ success: false });
            setSubmitting(false);
          } catch (err) {
            setStatus({ success: false });
            setErrors({ submit: err.message });
            setSubmitting(false);
          }
        }}
      >
            {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, setFieldValue, touched, values }) => (
          <form noValidate onSubmit={handleSubmit}>
            <Box sx={{ p: 2.5 }}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <Stack spacing={1.25}>
                    <InputLabel htmlFor="personal-first-name">First Name</InputLabel>
                    <TextField
                      fullWidth
                      id="personal-first-name"
                      value={values.firstname}
                      name="firstname"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      placeholder="First Name"
                      autoFocus
                      inputRef={inputRef}
                    />
                    {touched.firstname && errors.firstname && (
                      <FormHelperText error id="personal-first-name-helper">
                        {errors.firstname}
                      </FormHelperText>
                    )}
                  </Stack>
                </Grid>
                  <Grid item xs={12} sm={6}>
                  <Stack spacing={1.25}>
                    <InputLabel htmlFor="personal-middle-name">Middle Name</InputLabel>
                    <TextField
                      fullWidth
                      id="personal-middle-name"
                      value={values.middlename}
                      name="middlename"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      placeholder="Middle Name"
                    />
                    {touched.middlename && errors.middlename && (
                      <FormHelperText error id="personal-middle-name-helper">
                        {errors.middlename}
                      </FormHelperText>
                    )}
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Stack spacing={1.25}>
                    <InputLabel htmlFor="personal-last-name">Last Name</InputLabel>
                    <TextField
                      fullWidth
                      id="personal-last-name"
                      value={values.lastname}
                      name="lastname"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      placeholder="Last Name"
                    />
                    {touched.lastname && errors.lastname && (
                      <FormHelperText error id="personal-last-name-helper">
                        {errors.lastname}
                      </FormHelperText>
                    )}
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Stack spacing={1.25}>
                    <InputLabel htmlFor="personal-email">Email Address</InputLabel>
                    <TextField
                      type="email"
                      fullWidth
                      value={values.email}
                      name="email"
                      disabled
                      onBlur={handleBlur}
                      onChange={handleChange}
                      id="personal-email"
                      placeholder="Email Address"
                    />
                      <FormHelperText>To change e-mail please cancel subscription and re-subscribe.</FormHelperText>
                    {touched.email && errors.email && (
                      <FormHelperText error id="personal-email-helper">
                        {errors.email}
                      </FormHelperText>
                    )}
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Stack spacing={1.25}>
                    <InputLabel htmlFor="personal-date">Date of Birth (+18)</InputLabel>
                    <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
                      <Select
                        fullWidth
                        value={values.dob.getMonth().toString()}
                        name="dob-month"
                        onChange={(e) => handleChangeMonth(e, values.dob, setFieldValue)}
                      >
                        <MenuItem value="0">January</MenuItem>
                        <MenuItem value="1">February</MenuItem>
                        <MenuItem value="2">March</MenuItem>
                        <MenuItem value="3">April</MenuItem>
                        <MenuItem value="4">May</MenuItem>
                        <MenuItem value="5">June</MenuItem>
                        <MenuItem value="6">July</MenuItem>
                        <MenuItem value="7">August</MenuItem>
                        <MenuItem value="8">September</MenuItem>
                        <MenuItem value="9">October</MenuItem>
                        <MenuItem value="10">November</MenuItem>
                        <MenuItem value="11">December</MenuItem>
                      </Select>
                      <Select
                        fullWidth
                        value={values.dob.getDate().toString()}
                        name="dob-date"
                        onBlur={handleBlur}
                        onChange={(e) => handleChangeDay(e, values.dob, setFieldValue)}
                        MenuProps={MenuProps}
                      >
                        {[
                          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31
                        ].map((i) => (
                          <MenuItem
                            key={i}
                            value={i}
                            disabled={
                              (values.dob.getMonth() === 1 && i > (values.dob.getFullYear() % 4 === 0 ? 29 : 28)) ||
                              (values.dob.getMonth() % 2 !== 0 && values.dob.getMonth() < 7 && i > 30) ||
                              (values.dob.getMonth() % 2 === 0 && values.dob.getMonth() > 7 && i > 30)
                            }
                          >
                            {i}
                          </MenuItem>
                        ))}
                      </Select>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          sx={{ width: 1 }}
                          views={['year']}
                          value={values.dob}
                          maxDate={maxDate}
                          onChange={(newValue) => {
                            setFieldValue('dob', newValue);
                          }}
                        />
                      </LocalizationProvider>
                    </Stack>
                    {touched.dob && errors.dob && (
                      <FormHelperText error id="personal-dob-helper">
                        {errors.dob}
                      </FormHelperText>
                    )}
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Stack spacing={1.25}>
                    <InputLabel htmlFor="personal-phone">Phone Number</InputLabel>
                    <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
                        <TextField
                        fullWidth
                        id="personal-countryCode"
                        value={values.countryCode}
                        name="countryCode"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        placeholder="Country Code"
                      />
                      <TextField
                        fullWidth
                        id="personal-contact"
                        value={values.contact}
                        name="contact"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        placeholder="Contact Number"
                      />
                    </Stack>
                    {touched.contact && errors.contact && (
                      <FormHelperText error id="personal-contact-helper">
                        {errors.contact}
                      </FormHelperText>
                    )}
                  </Stack>
                </Grid>
              </Grid>
            </Box>
            <CardHeader title="Address" />
            <Divider />
            <Box sx={{ p: 2.5 }}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <Stack spacing={1.25}>
                    <InputLabel htmlFor="personal-addrees1">Address 01</InputLabel>
                    <TextField
                      multiline
                      rows={3}
                      fullWidth
                      id="personal-addrees1"
                      value={values.address}
                      name="address"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      placeholder="Address 01"
                    />
                    {touched.address && errors.address && (
                      <FormHelperText error id="personal-address-helper">
                        {errors.address}
                      </FormHelperText>
                    )}
                  </Stack>
                </Grid>
                {/*<Grid item xs={12} sm={6}>*/}
                {/*  <Stack spacing={1.25}>*/}
                {/*    <InputLabel htmlFor="personal-country">Country</InputLabel>*/}
                {/*    <Autocomplete*/}
                {/*      id="personal-country"*/}
                {/*      fullWidth*/}
                {/*      value={countries.filter((item) => item.code === values?.country)[0]}*/}
                {/*      onBlur={handleBlur}*/}
                {/*      onChange={(event, newValue) => {*/}
                {/*        setFieldValue('country', newValue === null ? '' : newValue.code);*/}
                {/*      }}*/}
                {/*      options={countries}*/}
                {/*      autoHighlight*/}
                {/*      isOptionEqualToValue={(option, value) => option.code === value?.code}*/}
                {/*      getOptionLabel={(option) => option.label}*/}
                {/*      renderOption={(props, option) => (*/}
                {/*        <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>*/}
                {/*          {option.code && (*/}
                {/*            <img*/}
                {/*              loading="lazy"*/}
                {/*              width="20"*/}
                {/*              src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}*/}
                {/*              srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}*/}
                {/*              alt=""*/}
                {/*            />*/}
                {/*          )}*/}
                {/*          {option.label}*/}
                {/*          {option.code && `(${option.code}) ${option.phone}`}*/}
                {/*        </Box>*/}
                {/*      )}*/}
                {/*      renderInput={(params) => (*/}
                {/*        <TextField*/}
                {/*          {...params}*/}
                {/*          placeholder="Choose a country"*/}
                {/*          name="country"*/}
                {/*          inputProps={{*/}
                {/*            ...params.inputProps,*/}
                {/*            autoComplete: 'new-password' // disable autocomplete and autofill*/}
                {/*          }}*/}
                {/*        />*/}
                {/*      )}*/}
                {/*    />*/}
                {/*    {touched.country && errors.country && (*/}
                {/*      <FormHelperText error id="personal-country-helper">*/}
                {/*        {errors.country}*/}
                {/*      </FormHelperText>*/}
                {/*    )}*/}
                {/*  </Stack>*/}
                {/*</Grid>*/}
                <Grid item xs={12} sm={6}>
                  <Stack spacing={1.25}>
                    <InputLabel htmlFor="personal-state">State</InputLabel>
                    <TextField
                      fullWidth
                      id="personal-state"
                      value={values.state}
                      name="state"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      placeholder="State"
                    />
                    {touched.state && errors.state && (
                      <FormHelperText error id="personal-state-helper">
                        {errors.state}
                      </FormHelperText>
                    )}
                  </Stack>
                </Grid>
              </Grid>
            </Box>

            <Box sx={{ p: 2.5 }}>

              <Stack direction="row" justifyContent="flex-end" alignItems="center" spacing={2} sx={{ mt: 2.5 }}>
                <Button variant="outlined" color="secondary">
                  Cancel
                </Button>
                <Button disabled={isSubmitting || Object.keys(errors).length !== 0} type="submit" variant="contained">
                  Save
                </Button>
              </Stack>
            </Box>
          </form>
        )}
          </Formik>
        </MainCard>
    )
}

export default TabPersonal;